import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { connect } from "react-redux";
import { getValue } from "../Reducers/reducer";
import { setValue } from "../Reducers/actions";
import MonthlyPrice from "./MonthlyPrice";
import Form from "../Form";

const style = {
  box: {
    display: "flex",
    marginBottom: 5
  },
  boxMonthly: {
    extend: "box",
    backgroundColor: "#FFFFFF",
    height: 165,
    borderTop: "3px solid #0E283D",
    border: "1px solid #F2F2F2",
    borderRadius: "0 0 3px 3px",
    width: 370,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginRight: 31
  },
  text: {
    marginTop: 28,
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 16,
    textAlign: "right"
  },
  textDevice: {
    extend: "text",
    marginLeft: 5
  },
  textDeviceSmall: {
    extend: "text",
    marginLeft: 10
  },
  boxValues: {
    display: "flex"
  }
};

const Monthly = ({ classes, objectValue, onChangeDevice, onChangeUpdate }) => {
  const devicePrice = objectValue.devicePrice;
  const activationPrice = objectValue.activationPrice;
  const storagePrice = objectValue.storagePrice;
  let perdevicePrice = devicePrice / objectValue.device;
  perdevicePrice = objectValue.device > 0 ? perdevicePrice : 0.0;
  let perdeviceActivation = activationPrice / objectValue.device;
  perdeviceActivation = objectValue.device > 0 ? perdeviceActivation : 0.0;
  const props = {
    storagePrice,
    devicePrice,
    perdevicePrice,
    perdeviceActivation,
    activationPrice
  };
  const deviceText =
    objectValue.device < 10000 ? classes.textDeviceSmall : classes.textDevice;

  return (
    <div className={classes.box}>
      <div className={classes.boxMonthly}>
        <div className={classes.boxValues}>
          <div className={deviceText}>Devices</div>
          <Form
            value={objectValue.device}
            onChange={onChangeDevice}
            text={""}
          />
        </div>
        <div className={classes.boxValues}>
          <div className={classes.text}>Update size</div>
          <Form
            value={objectValue.updateSize}
            onChange={onChangeUpdate}
            text={"MB"}
          />
        </div>
      </div>
      <MonthlyPrice {...props} />
    </div>
  );
};

Monthly.propTypes = {
  classes: PropTypes.object.isRequired,
  objectValue: PropTypes.object.isRequired,
  onChangeDevice: PropTypes.func.isRequired,
  onChangeUpdate: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  objectValue: getValue(state)
});

const mapDispatchToProps = {
  setValue
};

const mergeProps = (state, actions, props) => {
  return {
    ...state,
    onChangeDevice(total) {
      actions.setValue({
        device: total,
        updateSize: state.objectValue.updateSize,
        rollout: state.objectValue.rollout,
        percentualDevice: state.objectValue.percentualDevice
      });
    },
    onChangeUpdate(total) {
      actions.setValue({
        device: state.objectValue.device,
        updateSize: total,
        rollout: state.objectValue.rollout,
        percentualDevice: state.objectValue.percentualDevice
      });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(injectSheet(style)(Monthly));
